export const defaultLabelColor = "#4e4e4e";
interface PropsLabel {
  type?: any;
  bgcolor?: any;
  themeMode?: String;
  size?: number;
  isUnit?: boolean;
}

export function LabelIconsDetection({
  type,
  bgcolor = defaultLabelColor,
  themeMode,
  size = 18,
  isUnit = false,
}: PropsLabel) {
  if (type === "R") {
    return (
      <svg
        width={size || 19}
        height={size || 18}
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.0638 0L18.6021 1.0766L17.1287 1.81361V16.7957C17.1287 17.4304 16.6374 17.9506 16.0142 17.9964L15.9245 18H2.67766C2.04302 18 1.52278 17.5087 1.47702 16.8855L1.47341 16.7957V9.64127L0.538302 10.1085L0 9.03191L1.47341 8.29551V3.54894H2.67766V7.69338L18.0638 0ZM15.9245 2.41574L2.67766 9.03914V16.7957H6.29043V10.7745C6.29043 10.1398 6.78176 9.61959 7.40496 9.57323L7.49468 9.57022H11.1074C11.7421 9.57022 12.2623 10.0616 12.3087 10.6848L12.3117 10.7745V16.7957H15.9245V2.41574ZM11.1074 10.7745H7.49468V16.7957H11.1074V10.7745ZM14.1181 5.95745C14.4505 5.95745 14.7202 6.2272 14.7202 6.55958C14.7202 6.89195 14.4505 7.1617 14.1181 7.1617C13.7857 7.1617 13.516 6.89195 13.516 6.55958C13.516 6.2272 13.7857 5.95745 14.1181 5.95745Z"
          fill={bgcolor}
        />
      </svg>
    );
  }else{
    return <></>
  }
}
